<template>
  <div class="lists-wrap group">
    <div class="header group">
      <div class="header-menu pure-menu pure-menu-horizontal group">
        <router-link to="/" class="pure-menu-heading home-link" v-on:click.native="homeClick()"><i class="fal fa-home"></i> Matrix</router-link>
        <ul class="pure-menu-list main-menu">
          <li class="pure-menu-item pure-menu-has-children pure-menu-allow-hover account-menu-item"><a href="#" v-on:click.stop.prevent="menuOpenClick" class="pure-menu-link"><i class="fas fa-bars"></i></a>
            <ul class="pure-menu-children">
              <li class="pure-menu-item"><router-link to="/account" class="pure-menu-link">Account</router-link></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="lists-heading section-panel">
      <h3>Your lists</h3>
    </div>
    <div class="user-lists-wrap section-panel">
      <ul class="user-lists group">
        <li v-for="list in lists" :data-id="list.id" v-on:click="viewList(list.id, list.name)">
          <div class="movie-poster">
            <img :src="list.Poster" :alt="list.name" v-if="list.Poster" />
            <div class="movie-poster-holder" v-else></div>
          </div>
          <div class="list-title">
            <div class="list-title-inner">{{list.name}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  /* global mixpanel */
  import firebase from 'firebase'
  import Router from '../router'
  import db from './firebaseInit'

  export default {
    name: 'account',
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'Account'
    },
    data: function () {
      return {
        currentUserID: this.$globals.currentUserID,
        lists: []
      }
    },
    created () {
      let vm = this
      firebase.auth().onAuthStateChanged(function (user) {
        vm.user = null
        vm.name = ''
        vm.email = ''
        vm.photo = ''
        vm.userId = ''
        if (user) {
          vm.currentUserID = user.uid
          vm.$globals.currentUserID = user.uid
          vm.getLists()
        }
      })
    },
    methods: {
      homeClick: function () {
        this.$eventHub.$emit('navigate-home')
      },
      menuOpenClick: function () {

      },
      viewList: function (id, name) {
        Router.push({name: 'List', params: {id: id}})
      },
      getLists: function () {
        console.log('getLists')
        let vm = this
        var listsRef = db.collection('lists').orderBy('createdTimestamp', 'asc').where('userID', '==', vm.currentUserID)
        listsRef.get().then((querySnapshot) => {
          console.log('created query: ' + querySnapshot.docs.length)
          querySnapshot.forEach((doc) => {
            var listData = doc.data()
            listData.id = doc.id
            listData.docID = doc.id
            if (!vm.checkPresentInArray(vm.lists, listData.id, true)) {          
              // vm.lists.push(listData)
              vm.getListImage(listData)
            }
          })
        })
      },
      getListImage: function (list) {
        let vm = this
        if (list.films && list.films.length > 0 && !list.Poster) {
          db.collection('movies').where('id', '==', list.films[0]).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              var movieData = doc.data()
              list.Poster = 'https://image.tmdb.org/t/p/w342/' + movieData.PosterPath.replace(/ /g, "")
              vm.lists.push(list)
            })
          })
        } else {
          vm.lists.push(list)
        }
      },
      checkPresentInArray: function (inArr, ID, exists) {
        for (var i = 0; i < inArr.length; i++) {
          if (inArr[i].docID === ID) {
            return (exists === true) ? true : inArr[i]
          }
        }
      },
    }
  };
</script>

<style lang="scss" scoped>
  .lists-wrap {
    padding-top: 0;
    width: 100%;
    max-width: 400px;
    text-align: left;
    margin: 0 auto;
    background: #EFF3F7;

    & > .section-panel {
      background: #fff;
      padding: 15px;
      box-sizing: border-box;
      margin: 0 5px 5px;
    }
  }

  .header {
    margin: 5px;
  }

  .header-menu {
    background: rgb(41,100,134);
    background: -webkit-gradient(linear, left top, right top, from(rgba(41,100,134,1)), to(rgba(49,129,174,1)));
    background: linear-gradient(90deg, rgba(41,100,134,1) 0%, rgba(49,129,174,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#296486",endColorstr="#3181ae",GradientType=1);
    color: #fff;
    box-sizing: border-box;
    
    .pure-menu-heading {
      color: #fff;
      padding: 15px;
      font-size: 20px;
      float: left;
      text-transform: none;
      font-weight: bold;

      i {
        font-weight: normal;
        margin-right: 10px;
      }
    }
    .pure-menu-list {
      float: right;
      margin: 5px;
    }
    .pure-menu-list > .pure-menu-link {
      color: #fff;
      padding: 10px 18px;
      font-size: 20px;
    }
    .pure-menu-list .pure-menu-link:hover {
      color: #296486;
      background-color: #fff;
    }
  } /* end .header-menu */

  .lists-heading {
    text-align: left;

    h3 {
      margin: 10px 0;
    }
  }

  .user-lists-wrap {
    padding: 0 25px;
  }

  .user-lists {
    margin: 0 -2px;
    padding: 0;
    list-style: none;
    clear: both;

    li {
      float: left;
      width: 31.9%;
      margin: 0 2px 15px;
      cursor: pointer;
      
      .list-title {
        background: #2C3E50;
        color: #fff;
        padding: 10px;
        font-size: 13px;
        text-align: center;
        height: 70px;
        display: table;
        width: 100%;
        box-sizing: border-box;
        max-lines: 3;
      }
      .list-title-inner {
        display: table-cell;
        vertical-align: middle;
        word-break: break-word;
      }
      .movie-poster {
        max-height: 110px;
        display: block;
        overflow: hidden;
        cursor: pointer;
        margin-bottom: 5px;
        
        img {
          width: 100%;
          height: auto;
          display: block;
        }
      }
      .movie-poster-holder {
        height: 110px;
        background: #eee;
      }
    }
  } /* end .user-lists */
</style>

<style scoped>
.pure-menu-list.main-menu {
  float: right;
  margin: 5px 5px 0 0;
  font-size: 20px;
}
.pure-menu-list.main-menu > .pure-menu-item > a {
  cursor: default;
  color: #fff;
}
.pure-menu-list.main-menu .pure-menu-children {
  left: auto;
  right: 0;
  top: 46px;
  box-shadow: 0px 0px 10px -3px rgba(0,0,0,0.5);
}
.pure-menu-list.main-menu .pure-menu-children > .pure-menu-item {
  border-top: 1px solid #eaeaea;
}
.pure-menu-list.main-menu .pure-menu-children > .pure-menu-item:first-child {
  border-top-width: 0;
}
.pure-menu-list.main-menu .pure-menu-children .pure-menu-link {
  font-size: 16px;
  padding: 1em 1.3em;
}
..pure-menu-list.main-menu .pure-menu-link {
  color: #fff;
  padding: 13px 18px;
}
.pure-menu-list.main-menu .pure-menu-item:hover > .pure-menu-link {
  color: #296486;
  background-color: #fff;
}
.pure-menu-has-children>.pure-menu-link:after {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Lists.vue